import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import MapForm from '@galo-monitor/web-containers/forms/farm/MapForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const MapModal = (props) => {
  const {
    id,
    open,
    handleClose,
    mapObject,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)
  const [blockForm, setBlockForm] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    err => {
      const { response } = err
      setLoading(false)
      createDialog({
        id: 'error-overview-map',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(isEmpty(mapObject) ? 'register' : 'update')),
            this: toLower(t('map', { howMany: 1 }))
          })  }.`,
          message: t(response?.data?.errors?.[0]?.message)
        }
      })
    },
    [createDialog, mapObject, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', {
        this: t('map', { howMany: 1 })
      }) }
      maxWidth="xl"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
            disabled={ blockForm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <MapForm
        ref={ formRef }
        mapObject={ mapObject }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
        setBlockForm={ setBlockForm }
      />
    </Modal>
  )
}

MapModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  mapObject: PropTypes.object
}

MapModal.defaultProps = {
  mapObject: {}
}

export default MapModal
